import type { CalendarResponse, ScheduledPost } from '@qlk/shared';
import { useDroppable } from '@dnd-kit/core';

import { TheBaiDang } from './TheBaiDang.js';
import { TEN_THU, khoaNgayVn, ngayTrongKhoa } from './gioThiTruong.js';

export interface ONgayProps {
  date: string;
  nhan: string;
  posts: ScheduledPost[];
  homNay: boolean;
  onMo?: (post: ScheduledPost) => void;
  /** Lịch tháng dùng ô thấp hơn và chỉ hiện vài thẻ. */
  gon?: boolean;
}

export function ONgay({ date, nhan, posts, homNay, onMo, gon = false }: ONgayProps) {
  const { setNodeRef, isOver } = useDroppable({ id: `ngay-${date}`, data: { date } });

  const hien = gon ? posts.slice(0, 3) : posts;

  return (
    <div
      ref={setNodeRef}
      className={`flex flex-col rounded-the border bg-be-mat p-3 ${gon ? 'min-h-[120px]' : 'min-h-[420px]'} ${
        homNay ? 'border-nhan' : isOver ? 'border-nhan/60' : 'border-vien'
      }`}
    >
      <div className="mb-3 flex items-baseline justify-between gap-2">
        <span className="text-co-ban font-medium text-chu-phu">{nhan}</span>
        <span
          className={`so-lieu inline-flex size-7 items-center justify-center rounded-full text-co-ban font-semibold ${
            homNay ? 'bg-nhan text-white' : 'text-chu'
          }`}
        >
          {ngayTrongKhoa(date)}
        </span>
      </div>

      <div className="flex flex-col gap-2">
        {hien.map((p) => (
          <TheBaiDang key={p.id} post={p} onMo={onMo} />
        ))}
        {gon && posts.length > hien.length && (
          <p className="text-phu text-chu-mo">… thêm {posts.length - hien.length} bài</p>
        )}
      </div>
    </div>
  );
}

export interface LuoiTuanProps {
  lich: CalendarResponse;
  onMo?: (post: ScheduledPost) => void;
}

export function LuoiTuan({ lich, onMo }: LuoiTuanProps) {
  const homNay = khoaNgayVn(new Date());

  return (
    <div className="overflow-x-auto pb-2">
      <div className="grid min-w-[1000px] grid-cols-7 gap-4">
        {lich.days.map((ngay, i) => (
          <ONgay
            key={ngay.date}
            date={ngay.date}
            nhan={TEN_THU[i] ?? ''}
            posts={ngay.posts}
            homNay={ngay.date === homNay}
            onMo={onMo}
          />
        ))}
      </div>
    </div>
  );
}
